import feather from 'feather-icons';
import { AJAX_WP_Query } from 'ajax-wp-query';
import { renderSkeleton } from './components/skeletonLoader';

(function ($) {
	$(document).ready(function () {
		if ($('.wikpis-filter-taxonomy__filter-button')[0]) {
			$('.wikpis-filter-taxonomy__filter-button')[0].classList.add('active');
		}

		let postType = $('#wikpis-filter-taxonomy__post-type').val();
		let taxomony = $('#wikpis-filter-taxonomy__taxonomy').val();

		let actionType = 'overwrite';
		let wrapperElement = $('.wikpis-filter-taxonomy__content');
		let loadingElement = renderSkeleton();

		let requestData = {
			action: 'AJAX_WP_Query',
			queryArgs: {
				post_type: postType
			}
		};

		/**
		 * Event Listeners
		 */
		$('.wikpis-filter-taxonomy__search-input').change(function () {
			let search = $(this).val();
			if (search) {
				requestData.queryArgs.s = search;
			} else {
				delete requestData.queryArgs.s;
			}

			AJAX_WP_Query(requestData, responseFunction, actionType, wrapperElement, loadingElement);
		});

		$('.wikpis-filter-taxonomy__filter-button').click(function () {
			let category = $(this).val();

			if (category != 'all') {
				requestData.queryArgs.tax_query = [
					{
						relation: 'AND'
					},
					{
						type: 'Array',
						taxonomy: taxomony,
						field: 'slug',
						terms: category
					}
				];
			} else {
				delete requestData.queryArgs.tax_query;
			}

			$('.wikpis-filter-taxonomy__filter-button.active').removeClass('active');
			$(this).addClass('active');

			AJAX_WP_Query(requestData, responseFunction, actionType, wrapperElement, loadingElement);
		});

		/**
		 * DOM Functions
		 */

		const responseFunction = (res) => {
			if (res.length) {
				let posts = '';
				res.forEach((element) => {
					posts += renderPost(element);
				});
				setTimeout(() => {
					wrapperElement.html(posts);
				}, 1000);
			} else {
				setTimeout(() => {
					wrapperElement.html('<div><p>La búsqueda no arrojó resultados</p></div>');
				}, 1000);
			}
		};

		const renderPost = (element) => {
			let html = '';
			html += `
			<div class="wikpis-filter-taxonomy__item">
				${element.thumbnail}
				<div class="wikpis-filter-taxonomy__wrapper">
					<a href="${element.permalink}">
						<h3>${element.title}</h3>
					</a>
					<div class="wikpis-filter-taxonomy__excerpt">${element.excerpt}</div>
					<p class="wikpis-filter-taxonomy__date">
						${element.date}
					</p>
				</div>
			</div>
			`;
			return html;
		};

		feather.replace();
	});
})(jQuery);
